import React, {useEffect, useState} from 'react';
import ReadOnlyInputBasic from "../../../../components/input/ReadOnlyInputBasic";
import {useNavigate, useParams} from "react-router-dom";
import "../../../../components/detailLayout/detailListLayout.css";
import {
    ContentDetailTwoColLayout,
    DetailEntityShell,
    DetailFilePanel,
    DetailHeroSummaryProvider,
    DetailKvListValue,
    KV_LIST_TYPES,
    DetailKvReadOnly,
    DetailKvTable,
    DetailPanel,
    DetailRollupActions,
    DetailTabBar,
    useDetailEditing,
} from "../../../../components/detailLayout";
import {
    createPurchaseAssets,
    getPurchase,
    removePurchaseAssets,
    removePurchases,
    updatePurchase,
    updatePurchaseHandler
} from "../../../../api/asset/PurchaseService";
import {useDispatch, useSelector} from "react-redux";
import Th_title from "../../../../components/Th_title";
import {refresh, skeleton} from "../../../../redux/slice/apiSlice";
import {CodeSpecNum, UserType} from "../../../../constant/CodeSpecNum";
import {commonResponseMessage} from "../../../../components/commonmethod/CommonMethod";
import {CommonHistoryList} from "../../../settings/history/subPages/CommonHistoryList";
import Selector from "../../../../components/selector/Selector";
import {onUpdateClickListener} from "../../../../components/commonmethod/simmsDrawerMethod";
import {inputOnChange, inputOnKeyDown} from "../../../../components/commonmethod/simmsInputMethod";
import SimmsInput from "../../../../components/input/SimmsInput";
import SearchSelector from "../../../../components/searchSelector/SearchSelector";
import UserSelectionField from "../../../../components/selection/UserSelectionField";
import {AssetSearchFilters} from "../info/shared/AssetSearchFilters";
import {handleActiveError} from "../../../../components/sonner/ToastBasic";
import SimmsTextArea from "../../../../components/input/SimmsTextArea";
import {dateOnChange, dateOnSelected} from "../../../../components/commonmethod/simmsDateMethod";
import SimmsDatePicker from "../../../../components/datepicker/SimmsDatePicker";
import SimmsInputSearch from "../../../../components/input/SimmsInputSearch";
import SimmsDrawerSearch from "../../../../components/drawer/simms/SimmsDrawerSearch";


/**
 * &구매 상세보기
 * */

function PurchaseView() {
    const platFrom = useSelector(state =>state.auth.platFrom);
    const dispatch = useDispatch();
    const { id } = useParams();
    const [purchase, setPurchase] = useState();
    const navigate = useNavigate();
    const refreshState = useSelector(state => state.api.status);


    const [tab, setTab] = useState([
        {clicked: true, name: "기본정보"},
        {clicked: false, name: "이력관리"},
    ]);

    // 자산추가
    const AssetsHandler = async (id, data, add) => {
        let response = add ? await createPurchaseAssets(id, data) : await removePurchaseAssets(id, data);
        return commonResponseMessage(response, add, "자산");
    }

    const hanlerDelete = async (v) => {
        const handlerIds = purchase.handler.map(handler => handler.id);
        if (handlerIds.length === 1){
            alert("담당자는 최소 한명이상 존재해야 합니다.")
            return;
        }else {
            await updatePurchaseHandler(id, v.id, false, v.name);
            const filteredHandler = purchase.handler.filter(handler => handler.id !== v.id);
            setPurchase(prev => ({...prev, handler: [...filteredHandler]}))
        }
    }

    const handleHandlersMultiFlat = async (list) => {
        const next = Array.isArray(list) ? list.filter(Boolean) : [];
        const prev = purchase?.handler ?? [];
        const prevIds = new Set(prev.map((h) => h.id));
        const nextIds = new Set(next.map((h) => h.id));

        for (const item of next) {
            if (!prevIds.has(item.id)) {
                await updatePurchaseHandler(id, item.id, true, item.name);
                setPurchase((p) => ({...p, handler: [...(p.handler ?? []), item]}));
            }
        }

        for (const item of prev) {
            if (!nextIds.has(item.id)) {
                await hanlerDelete(item);
            }
        }
    };

    const handleRemovePurchase = async () => {
        const response = await removePurchases({ids: [id]});
        if (response?.status === 200) {
            alert("구매가 정상적으로 삭제되었습니다.");
            navigate("/asset/purchase");
        }
    };

    const assetDelete = async (v) => {
        const response = await AssetsHandler(id, v.id, false);
        if (response?.status === 200) {
            setPurchase((prev) => ({
                ...prev,
                asset: (prev.asset ?? []).filter((asset) => asset.id !== v.id),
            }));
        }
    };

    const handleAssetsMultiFlat = async (list) => {
        const next = Array.isArray(list) ? list.filter(Boolean) : [];
        const prev = purchase?.asset ?? [];
        const prevIds = new Set(prev.map((a) => a.id));
        const nextIds = new Set(next.map((a) => a.id));

        for (const item of next) {
            if (!prevIds.has(item.id)) {
                const response = await createPurchaseAssets(id, item.id);
                if (response.status === 200) {
                    setPurchase((p) => ({...p, asset: [...(p.asset ?? []), item]}));
                    commonResponseMessage(response, true, "자산");
                } else if (response.status === 201 || response.status === 202) {
                    handleActiveError({
                        message: response.data.title,
                        description: response.data.reason,
                    });
                }
            }
        }

        for (const item of prev) {
            if (!nextIds.has(item.id)) {
                await assetDelete(item);
            }
        }
    };



    useEffect(() => {
        if (!id) return;

        setPurchase(undefined);
        dispatch(skeleton(true));
        getPurchase(id).then(_ =>{
            if(_.status===200){
                setPurchase(_.data);
                //assets 데이터를 가공해서 asset에 저장
                const transformedAssets = _.data.assets.map(item => item.asset);
                setPurchase(prevPurchase => ({
                    ...prevPurchase, // 이전 상태 유지
                    asset: transformedAssets // asset 덮어쓰기 또는 추가
                }));

            }else if(_.status===201){
                alert(_.data.title +"\n"+_.data.reason)
                navigate("/purchase");
            }
        }).then(() => {
            dispatch(skeleton(false));
            dispatch(refresh(false));

        }).catch(error => {
            console.error("An error occurred:", error);
            dispatch(skeleton(false));
            dispatch(refresh(false));

        });
    }, [id, refreshState, dispatch, navigate])




    if(purchase){
    return (
        <div className="common-container container-height border-l-gray detail-list-layout asset-detail-list-layout">
            <DetailHeroSummaryProvider>
                <DetailTabBar tabs={tab} setTabs={setTab} />

            {tab[0].clicked && (
            <DetailEntityShell
                key={id}
                title={purchase.title || "구매상세"}
                meta={purchase.purchaseNumber ? `구매번호 ${purchase.purchaseNumber}` : undefined}
                canUpdate={purchase.auth?.update ?? true}
                listUrl="/asset/purchase"
                scrollMode="columns"
                rollupActions={(purchase.auth?.delete ?? true) ? <DetailRollupActions remove={handleRemovePurchase} /> : null}
            >
                <PurchaseDetailBody
                    purchase={purchase}
                    setPurchase={setPurchase}
                    id={id}
                    platFrom={platFrom}
                    hanlerDelete={hanlerDelete}
                    handleHandlersMultiFlat={handleHandlersMultiFlat}
                    handleAssetsMultiFlat={handleAssetsMultiFlat}
                    assetDelete={assetDelete}
                />
            </DetailEntityShell>
            )}


            {tab[1].clicked && <CommonHistoryList id={id} tableName={"구매관리"} />}
            </DetailHeroSummaryProvider>
            </div>
    );
    }
}

function PurchaseDetailBody({
    purchase,
    setPurchase,
    id,
    platFrom,
    hanlerDelete,
    handleHandlersMultiFlat,
    handleAssetsMultiFlat,
    assetDelete,
}) {
    const isEditing = useDetailEditing();
    const fieldAuth = isEditing && (purchase.auth?.update ?? true);

    return (
        <ContentDetailTwoColLayout
            main={
            <DetailPanel title="기본정보">
                <DetailKvTable>
                    <tbody>
                    <tr>
                        <DetailKvReadOnly label="등록일시" value={purchase.createdAt} type="date" />
                        <DetailKvReadOnly label="수정일시" value={purchase.updatedAt} type="date" />
                    </tr>
                    <tr>
                        <DetailKvReadOnly label="등록자" value={purchase.createdBy?.name} />
                        <DetailKvReadOnly label="수정자" value={purchase.updatedBy?.name} />
                    </tr>
                    <tr>
                        <Th_title title={"구매정보 명칭"} colspan={1} required={true} className="fieldset-td" auth={fieldAuth}>
                            <SimmsInput onChange={(v)=>inputOnChange(setPurchase,"title", v, true)}
                                        update
                                        onKeyDown={(v, e)=>inputOnKeyDown(setPurchase, updatePurchase, id, "title", v, e, true)}
                                        data={purchase.title} />
                        </Th_title>
                        <Th_title title={"구매번호"} colspan={1} className="fieldset-td" auth={fieldAuth}>
                            <SimmsInput onChange={(v)=>inputOnChange(setPurchase,"purchaseNumber", v, false)}
                                        update
                                        onKeyDown={(v, e)=>inputOnKeyDown(setPurchase, updatePurchase, id, "purchaseNumber", v, e, false)}
                                        data={purchase.purchaseNumber} />
                        </Th_title>

                    </tr>
                    <tr>
                        <Th_title title={"업체명"} colspan={1} className="fieldset-td" auth={fieldAuth}>
                            <Selector
                                onChange={(v)=>onUpdateClickListener(setPurchase, updatePurchase, "company", purchase, v, false)}
                                data={purchase.company}
                                entity={"company"}
                            >
                                <SimmsInputSearch type={'TEXT'} placeHolder={"업체명"} />
                            </Selector>
                        </Th_title>
                        <Th_title title={"담당자"} colspan={1} className="fieldset-td fieldset-td-input relative align-top" auth={fieldAuth}>
                            {isEditing ? (
                                <UserSelectionField
                                    layout="inline"
                                    data={purchase.handler}
                                    onRemove={(v) => hanlerDelete(v)}
                                >
                                    <SearchSelector
                                        auth={fieldAuth}
                                        multiSelect
                                        variant="compact"
                                        entity="userAccount"
                                        uniqueKey={UserType.handlers}
                                        data={purchase.handler}
                                        placeHolder="사용자명"
                                        onChange={(v) => {
                                            if (v?.__multiFlat) {
                                                handleHandlersMultiFlat(v.__multiFlat);
                                            }
                                        }}
                                    >
                                        <SimmsInputSearch type="TEXT" placeHolder="사용자명" />
                                        <SimmsDrawerSearch showLabel title="부서" entity="department" target="department" recursive />
                                        <SimmsDrawerSearch showLabel title="업체" entity="company" target="company" />
                                    </SearchSelector>
                                </UserSelectionField>
                            ) : (
                                <DetailKvListValue items={purchase.handler} listType={KV_LIST_TYPES.user} />
                            )}
                        </Th_title>
                    </tr>
                    <tr className="asset-detail-kv-row--auto">
                        <Th_title title={"구매 일시"} colspan={1} className="fieldset-td" auth={fieldAuth}>
                            <SimmsDatePicker onChange={(v) => dateOnChange(setPurchase, "purchaseStartDate", v, false)}
                                             update
                                             onUpdate={(v) => dateOnSelected(setPurchase, updatePurchase, id, "purchaseStartDate", v, false)}
                                             data={purchase.purchaseStartDate}/>

                        </Th_title>
                        <Th_title title={"자산목록"} colspan={1} className="fieldset-td relative align-top" auth={fieldAuth}>
                            {isEditing ? (
                                <UserSelectionField
                                    layout="inline"
                                    data={purchase.asset}
                                    countUnit="개"
                                    chipEntity="asset"
                                    listModalTitle="자산목록"
                                    onRemove={(v) => assetDelete(v)}
                                >
                                    <SearchSelector
                                        auth={fieldAuth}
                                        multiSelect
                                        variant="compact"
                                        entity="asset"
                                        uniqueKey="assets"
                                        data={purchase.asset}
                                        placeHolder="자산명"
                                        onChange={(v) => {
                                            if (v?.__multiFlat) {
                                                handleAssetsMultiFlat(v.__multiFlat);
                                            }
                                        }}
                                    >
                                        <AssetSearchFilters platFrom={platFrom} />
                                    </SearchSelector>
                                </UserSelectionField>
                            ) : (
                                <DetailKvListValue items={purchase.asset} listType={KV_LIST_TYPES.asset} />
                            )}
                        </Th_title>

                    </tr>
                    <tr>
                        <Th_title title={"공급방법(도입방법)"} className="fieldset-td" colspan={1} auth={fieldAuth}>
                            <Selector
                                onChange={(v)=>onUpdateClickListener(setPurchase, updatePurchase, "method", purchase, v, false)}
                                data={purchase.method}
                                entity={"code"}
                                parentKey={CodeSpecNum.PurchaseSupplyMethodCode}
                                recursive
                            />
                        </Th_title>
                        <Th_title title={"공급구분(도입형태)"} className="fieldset-td" colspan={1} auth={fieldAuth}>
                            <Selector
                                onChange={(v)=>onUpdateClickListener(setPurchase, updatePurchase, "category", purchase, v, false)}
                                data={purchase.category}
                                entity={"code"}
                                parentKey={CodeSpecNum.PurchaseSupplyCategoryCode}
                                recursive
                            />
                        </Th_title>
                    </tr>

                    <tr>
                        <Th_title title={"구매 수량"} colspan={1} className="fieldset-td" auth={fieldAuth}>
                            <SimmsInput onChange={(v)=>inputOnChange(setPurchase,"purchaseQuantity", v, false)}
                                        update
                                        onKeyDown={(v, e)=>inputOnKeyDown(setPurchase, updatePurchase, id, "purchaseQuantity", v, e, false)}
                                        data={purchase.purchaseQuantity}
                                        constraint={{type: "number"}}/>
                        </Th_title>
                        <Th_title title={"사용년수(내용연수)"} colspan={1} className="fieldset-td" auth={fieldAuth}>
                            <SimmsInput onChange={(v)=>inputOnChange(setPurchase,"yearsUse", v, false)}
                                        update
                                        onKeyDown={(v, e)=>inputOnKeyDown(setPurchase, updatePurchase, id, "yearsUse", v, e, false)}
                                        data={purchase.yearsUse}
                                        constraint={{type: "number"}}/>
                        </Th_title>
                    </tr>

                    <tr>
                        <Th_title title={"구매 단가"} colspan={1} className="fieldset-td" auth={fieldAuth}>
                            <SimmsInput onChange={(v)=>inputOnChange(setPurchase,"purchasePrice", v, false)}
                                        update
                                        onKeyDown={(v, e)=>inputOnKeyDown(setPurchase, updatePurchase, id, "purchasePrice", v, e, false)}
                                        data={purchase.purchasePrice}
                                        constraint={{type: "number"}}/>
                        </Th_title>
                        <Th_title title={"구매총금액(VAT포함)"} colspan={1} className="fieldset-td" auth={fieldAuth}>
                            <SimmsInput onChange={(v)=>inputOnChange(setPurchase,"purchaseTotalPrice", v, false)}
                                        update
                                        onKeyDown={(v, e)=>inputOnKeyDown(setPurchase, updatePurchase, id, "purchaseTotalPrice", v, e, false)}
                                        data={purchase.purchaseTotalPrice}
                                        constraint={{type: "number"}}/>
                        </Th_title>
                    </tr>

                    <tr>
                        <Th_title title={"년 유지보수금액"} colspan={1} className="fieldset-td" auth={fieldAuth}>
                            <SimmsInput onChange={(v)=>inputOnChange(setPurchase,"maintenancePriceYear", v, false)}
                                        update
                                        onKeyDown={(v, e)=>inputOnKeyDown(setPurchase, updatePurchase, id, "maintenancePriceYear", v, e, false)}
                                        data={purchase.maintenancePriceYear}
                                        constraint={{type: "number"}}/>
                        </Th_title>
                        <Th_title title={"월 유지보수금액"} colspan={1} className="fieldset-td" auth={fieldAuth}>
                            <SimmsInput onChange={(v)=>inputOnChange(setPurchase,"maintenancePriceMonth", v, false)}
                                        update
                                        onKeyDown={(v, e)=>inputOnKeyDown(setPurchase, updatePurchase, id, "maintenancePriceMonth", v, e, false)}
                                        data={purchase.maintenancePriceMonth}
                                        constraint={{type: "number"}}/>
                        </Th_title>
                    </tr>
                    <tr>
                        <Th_title title={"유지보수 요율(%)"} colspan={3} className="fieldset-td" auth={fieldAuth}>
                            <SimmsInput onChange={(v)=>inputOnChange(setPurchase,"maintenanceTariff", v, false)}
                                        update
                                        onKeyDown={(v, e)=>inputOnKeyDown(setPurchase, updatePurchase, id, "maintenanceTariff", v, e, false)}
                                        data={purchase.maintenanceTariff}
                                        constraint={{type: "number"}}/>
                        </Th_title>
                    </tr>

                    <tr>
                        <Th_title title={"비고사항"} colspan={3} className="fieldset-td" auth={fieldAuth}>
                            <SimmsTextArea onChange={(v)=>inputOnChange(setPurchase, "etc", v, false)}
                                           update
                                           style={{width: "100%"}}
                                           onKeyDown={(v,e)=>inputOnKeyDown(setPurchase, updatePurchase, purchase.id, "etc", v,e,false)}
                                           data={purchase.etc} />
                        </Th_title>
                    </tr>

                    </tbody>
                </DetailKvTable>
                </DetailPanel>
            }
            aside={
                <DetailFilePanel
                    isEditing={isEditing}
                    tableInfo={{tableName: "Purchases", joinKey: id}}
                />
            }
        />
    );
}

export default PurchaseView;
